import React, { useEffect, useState, useRef } from "react";
import { useDispatch, useSelector } from "react-redux";
import AdminTable from "../Administrator/Helpers/AdminTable";
import { paramsAction } from "../../store/Slices/ParamsSlice";
import TableInput from "../../components/TableInput";
import { versionAction } from "src/store/Slices/VersionsSlice";
import AntdMobileTable from "src/components/AntdMobileTable/AntdMobileTable";

const Params = ({ mnemo }) => {
    const dispatch = useDispatch();
    const searchInput = useRef(null);

    const filterOptionsArr = [
        { label: "Фильрация", value: 0, index: undefined },
        { label: "По номеру", value: 1, index: "id", title: "Параметр" },
        {
            label: "По наименованию",
            value: 2,
            index: "name",
            title: "Наименование",
        },
        { label: "По значению", value: 3, index: "value", title: "Значение" },
    ];

    const { params, isLoading } = useSelector((state) => state.ParamsSlice);

    const [isDeleted, setIsDeleted] = useState(false);
    const [page, setPage] = useState(1);
    const [pageSize, setPageSize] = useState(20);
    const [paramInfo, setParamInfo] = useState();

    const rows = params?.data?.value?.rows.map((element) => {
        return {
            ...element,
            value: (
                <TableInput
                    defaultValue={element.value}
                    completeHandler={(value) => {
                        onClickSave(element.id, value);
                    }}
                    disabled={
                        !mnemo?.children[0]?.children?.find(
                            (el) => el.mnemo === "updateBtn"
                        )
                    }
                />
            ),
        };
    });

    useEffect(() => {
        dispatch(paramsAction({ flag: "get" }));
    }, []);

    const onClickSave = (id, value) => {
        dispatch(
            paramsAction({
                flag: "post",
                value: {
                    id: id,
                    value: value,
                },
            })
        );
    };

    const handlePaginationChange = (page, pageSize) => {
        dispatch(
            versionAction({
                flag: "get",
                value: {
                    count: pageSize,
                    offset: pageSize * (page - 1),
                },
            })
        );
        setPage(page);
        setPageSize(pageSize);
    };

    const onClickSearchItem = (selectedKeys, dataIndex) => {
        setPage(1);
        setPageSize(20);
        dispatch(
            versionAction({
                flag: "get",
                value: {
                    isDeleted: isDeleted,
                    [`${dataIndex}`]: selectedKeys[0],
                },
            })
        );
    };

    const handleTableChange = (pagination, filters, sorter) => {
        dispatch(
            paramsAction({
                flag: "get",
                value: {
                    isDeleted: filters.isDeleted,
                    count: pagination.pageSize,
                    offset: pagination.pageSize * (pagination.current - 1),
                    orderBy: sorter?.column?.dataIndex,
                    isDesc: sorter.order
                        ? sorter.order === "ascend"
                            ? true
                            : false
                        : undefined,
                },
            })
        );
        setPage(pagination.current);
        setPageSize(pagination.pageSize);
    };

    return (
        <>
            {window.innerWidth >= 768 ? (
                <AdminTable
                    page={page}
                    setPage={setPage}
                    pageSize={pageSize}
                    setPageSize={setPageSize}
                    onChange={handleTableChange}
                    loading={isLoading}
                    onClickRowOne={(record) => {
                        setParamInfo(record);
                    }}
                    columns={params}
                    rows={rows}
                    total={params?.data?.value?.totalCount}
                    searchble={false}
                />
            ) : (
                <AntdMobileTable
                    page={page}
                    setPage={setPage}
                    setPageSize={setPageSize}
                    elementsList={params}
                    elementsListLoading={isLoading}
                    //setIsOpenAddEditModal={isOpenAddEditModal}
                    handlePaginationChange={handlePaginationChange}
                    onChange={handleTableChange}
                    clickOnAction={onClickSave}
                    filterOptionsArr={filterOptionsArr}
                    mnemo={mnemo}
                    searchInput={searchInput}
                    onClickSearchItem={onClickSearchItem}
                />
            )}
        </>
    );
};

export default Params;
